const e = {
  name: "Checkmark",
  dimensions: { width: 40, height: 29 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 29.3" style="enable-background:new 0 0 40 29.3;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34.3,0L40,5.7L16.3,29.3L0,13l5.7-5.7L16.3,18L34.3,0z M34.3,2.8l-18,18L5.7,10.2L2.8,13l13.5,13.5L37.2,5.7
			L34.3,2.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Checkmark
};
